import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { IQualifiedPersonViewModel, IUserViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreUsersService } from '@services/cleanfill-core/store-users/store-users.service';
import { Observable, of } from 'rxjs';
import { UserType } from '../enums/user-type.enum';

@Injectable()
export class UserResolver implements Resolve<IUserViewModel | IQualifiedPersonViewModel> {
  constructor(private userStore: StoreUsersService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IUserViewModel> | Promise<IUserViewModel> | Promise<IQualifiedPersonViewModel> | Observable<IQualifiedPersonViewModel> {
    const userUniqueId = route.params.userUniqueId;
    const userType = route.params.userType;
    if (!userUniqueId) {
      return of(undefined);
    }
    if (userType === UserType.SITE_USER) {
      return this.userStore.loadUser(userUniqueId);
    }
    if (userType === UserType.QP_USER) {
      return this.userStore.loadQP(userUniqueId);
    }
  }
}
